"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRINGS_COLLECTION_NAME = exports.COLLECTION_NAME = exports.BUCKET_NAME = void 0;
/** Storage bucket where template resources are stored. */
exports.BUCKET_NAME = 'templates';
/** Firestore collection where templates are stored. */
exports.COLLECTION_NAME = 'templates';
/** Firestore collection where strings are stored. */
exports.STRINGS_COLLECTION_NAME = 'strings';
